import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module 'bender-url!../../img/start-kno... Remove this comment to see the full error message
import imageUrl from 'bender-url!../../img/start-knowledge-base.png';
import { Image } from 'foundations-components/transitional/components/Image';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { Header } from 'foundations-components/transitional/components/Header';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class OnboardingStart extends Component {
  render() {
    const {
      isSetupDisabled,
      onClick
    } = this.props;
    return /*#__PURE__*/_jsx(ListingPage, {
      "data-test-id": "onboarding-start",
      headerComponent: /*#__PURE__*/_jsx(Header, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.knowledge"
        })
      }),
      children: /*#__PURE__*/_jsx(EmptyState, {
        maxWidth: 980,
        primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h4", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.onboarding.start.title"
            })
          }), /*#__PURE__*/_jsxs(View, {
            paddingInlineEnd: "800",
            as: "div",
            children: [/*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.onboarding.start.firstParagraph"
              })
            }), /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "knowledgeContentUI.onboarding.start.secondParagraph"
              })
            })]
          }), /*#__PURE__*/_jsx(Button, {
            marginBlockStart: "900",
            marginInlineEnd: "1500",
            "data-test-id": "setup-knowledge-base",
            disabled: isSetupDisabled,
            onClick: onClick,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.onboarding.start.button"
            })
          })]
        }),
        secondaryContent: /*#__PURE__*/_jsx(Image, {
          src: imageUrl
        }),
        secondaryContentWidth: 400
      })
    });
  }
}
OnboardingStart.propTypes = {
  isSetupDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
export default OnboardingStart;